// Consolidated demo bracket outcome datasets for the landing page.
// Single source of truth to simplify maintenance.

import type { Outcome } from "@landing/types"

// -----------------------------
// NFL – 2026 Super Bowl
// -----------------------------
export const nflOutcomes: Outcome[] = [
  {
    slug: "kansas-city-chiefs",
    name: "Kansas City Chiefs",
    fanbase: "Chiefs Kingdom",
    acronym: "KC",
    price: "30.0",
    seed: "1",
    imageSrc: "https://a.espncdn.com/combiner/i?img=/i/teamlogos/nfl/500/kc.png",
    primaryColor: "#E31837",
    secondaryColor: "#FFB612",
    state: "active",
    marketSlug: "nfl-playoffs-2024",
  },
  {
    slug: "san-francisco-49ers",
    name: "San Francisco 49ers",
    fanbase: "Niner Nation",
    acronym: "SF",
    price: "21.0",
    seed: "2",
    imageSrc: "https://a.espncdn.com/combiner/i?img=/i/teamlogos/nfl/500/sf.png",
    primaryColor: "#AA0000",
    secondaryColor: "#B3995D",
    state: "active",
    marketSlug: "nfl-playoffs-2024",
  },
  {
    slug: "buffalo-bills",
    name: "Buffalo Bills",
    fanbase: "Bills Mafia",
    acronym: "BUF",
    price: "15.0",
    seed: "3",
    imageSrc: "https://a.espncdn.com/combiner/i?img=/i/teamlogos/nfl/500/buf.png",
    primaryColor: "#00338D",
    secondaryColor: "#C60C30",
    state: "active",
    marketSlug: "nfl-playoffs-2024",
  },
  {
    slug: "philadelphia-eagles",
    name: "Philadelphia Eagles",
    fanbase: "Eagles Fans",
    acronym: "PHI",
    price: "26.0",
    seed: "4",
    imageSrc: "https://a.espncdn.com/combiner/i?img=/i/teamlogos/nfl/500/phi.png",
    primaryColor: "#004953",
    secondaryColor: "#A5ACAF",
    state: "active",
    marketSlug: "nfl-playoffs-2024",
  },
  {
    slug: "cincinnati-bengals",
    name: "Cincinnati Bengals",
    fanbase: "Who Dey Nation",
    acronym: "CIN",
    price: "8.0",
    seed: "5",
    imageSrc: "https://a.espncdn.com/combiner/i?img=/i/teamlogos/nfl/500/cin.png",
    primaryColor: "#FB4F14",
    secondaryColor: "#000000",
    state: "active",
    marketSlug: "nfl-playoffs-2024",
  },
  {
    slug: "dallas-cowboys",
    name: "Dallas Cowboys",
    fanbase: "America's Team",
    acronym: "DAL",
    price: "7.0",
    seed: "6",
    imageSrc: "https://a.espncdn.com/combiner/i?img=/i/teamlogos/nfl/500/dal.png",
    primaryColor: "#041E42",
    secondaryColor: "#869397",
    state: "active",
    marketSlug: "nfl-playoffs-2024",
  },
  {
    slug: "baltimore-ravens",
    name: "Baltimore Ravens",
    fanbase: "Ravens Flock",
    acronym: "BAL",
    price: "7.0",
    seed: "7",
    imageSrc: "https://a.espncdn.com/combiner/i?img=/i/teamlogos/nfl/500/bal.png",
    primaryColor: "#241773",
    secondaryColor: "#000000",
    state: "active",
    marketSlug: "nfl-playoffs-2024",
  },
  {
    slug: "detroit-lions",
    name: "Detroit Lions",
    fanbase: "One Pride",
    acronym: "DET",
    price: "6.0",
    seed: "8",
    imageSrc: "https://a.espncdn.com/combiner/i?img=/i/teamlogos/nfl/500/det.png",
    primaryColor: "#0076B6",
    secondaryColor: "#B0B7BC",
    state: "active",
    marketSlug: "nfl-playoffs-2024",
  },
]

// -----------------------------
// College Football – 2026 Playoff
// -----------------------------
export const cfb2026Outcomes: Outcome[] = [
  {
    slug: "georgia-bulldogs",
    name: "Georgia Bulldogs",
    fanbase: "Dawg Nation",
    acronym: "UGA",
    price: "22.0",
    seed: "1",
    imageSrc: "https://a.espncdn.com/i/teamlogos/ncaa/500/61.png",
    primaryColor: "#BA0C2F",
    secondaryColor: "#000000",
    state: "active",
    marketSlug: "cfb-champion-2026",
  },
  {
    slug: "alabama-crimson-tide",
    name: "Alabama Crimson Tide",
    fanbase: "Bama Fans",
    acronym: "ALA",
    price: "18.0",
    seed: "2",
    imageSrc: "https://a.espncdn.com/i/teamlogos/ncaa/500/333.png",
    primaryColor: "#9E1B32",
    secondaryColor: "#FFFFFF",
    state: "active",
    marketSlug: "cfb-champion-2026",
  },
  {
    slug: "ohio-state-buckeyes",
    name: "Ohio State Buckeyes",
    fanbase: "Buckeye Nation",
    acronym: "OSU",
    price: "14.0",
    seed: "3",
    imageSrc: "https://a.espncdn.com/i/teamlogos/ncaa/500/194.png",
    primaryColor: "#BB0000",
    secondaryColor: "#666666",
    state: "active",
    marketSlug: "cfb-champion-2026",
  },
  {
    slug: "michigan-wolverines",
    name: "Michigan Wolverines",
    fanbase: "Go Blue",
    acronym: "MICH",
    price: "12.0",
    seed: "4",
    imageSrc: "https://a.espncdn.com/i/teamlogos/ncaa/500/130.png",
    primaryColor: "#00274C",
    secondaryColor: "#FFCB05",
    state: "active",
    marketSlug: "cfb-champion-2026",
  },
  {
    slug: "texas-longhorns",
    name: "Texas Longhorns",
    fanbase: "Hook Em",
    acronym: "TEX",
    price: "8.0",
    seed: "5",
    imageSrc: "https://a.espncdn.com/i/teamlogos/ncaa/500/251.png",
    primaryColor: "#BF5700",
    secondaryColor: "#FFFFFF",
    state: "active",
    marketSlug: "cfb-champion-2026",
  },
  {
    slug: "usc-trojans",
    name: "USC Trojans",
    fanbase: "Trojan Family",
    acronym: "USC",
    price: "6.0",
    seed: "6",
    imageSrc: "https://a.espncdn.com/i/teamlogos/ncaa/500/30.png",
    primaryColor: "#990000",
    secondaryColor: "#FFCC00",
    state: "active",
    marketSlug: "cfb-champion-2026",
  },
  {
    slug: "clemson-tigers",
    name: "Clemson Tigers",
    fanbase: "Clemson Family",
    acronym: "CLEM",
    price: "5.0",
    seed: "7",
    imageSrc: "https://a.espncdn.com/i/teamlogos/ncaa/500/228.png",
    primaryColor: "#F66733",
    secondaryColor: "#522D80",
    state: "active",
    marketSlug: "cfb-champion-2026",
  },
  {
    slug: "notre-dame-fighting-irish",
    name: "Notre Dame Fighting Irish",
    fanbase: "Irish Fans",
    acronym: "ND",
    price: "4.0",
    seed: "8",
    imageSrc: "https://a.espncdn.com/i/teamlogos/ncaa/500/87.png",
    primaryColor: "#0C2340",
    secondaryColor: "#AE9142",
    state: "active",
    marketSlug: "cfb-champion-2026",
  },
  {
    slug: "oregon-ducks",
    name: "Oregon Ducks",
    fanbase: "Duck Nation",
    acronym: "ORE",
    price: "3.0",
    seed: "9",
    imageSrc: "https://a.espncdn.com/i/teamlogos/ncaa/500/2483.png",
    primaryColor: "#004F39",
    secondaryColor: "#FFF200",
    state: "active",
    marketSlug: "cfb-champion-2026",
  },
  {
    slug: "florida-state-seminoles",
    name: "Florida State Seminoles",
    fanbase: "Nole Nation",
    acronym: "FSU",
    price: "2.0",
    seed: "10",
    imageSrc: "https://a.espncdn.com/i/teamlogos/ncaa/500/52.png",
    primaryColor: "#782F40",
    secondaryColor: "#CEB888",
    state: "active",
    marketSlug: "cfb-champion-2026",
  },
]

// -----------------------------
// Oscars 2025 – Best Picture (fictional data)
// -----------------------------
export const oscars2025Outcomes: Outcome[] = [
  {
    slug: "the-galactic-odyssey",
    name: "The Galactic Odyssey",
    fanbase: "Sci-Fi Fans",
    acronym: "TGO",
    price: "22.0",
    seed: "1",
    imageSrc: "#1f2937",
    primaryColor: "#1f2937",
    secondaryColor: "#111827",
    state: "active",
    marketSlug: "oscars-best-picture-2025",
  },
  {
    slug: "heart-of-the-mountain",
    name: "Heart of the Mountain",
    fanbase: "Drama Lovers",
    acronym: "HOTM",
    price: "18.0",
    seed: "2",
    imageSrc: "#4b5563",
    primaryColor: "#4b5563",
    secondaryColor: "#111827",
    state: "active",
    marketSlug: "oscars-best-picture-2025",
  },
  {
    slug: "city-of-dreams",
    name: "City of Dreams",
    fanbase: "Film Buffs",
    acronym: "COD",
    price: "14.0",
    seed: "3",
    imageSrc: "#6b7280",
    primaryColor: "#6b7280",
    secondaryColor: "#374151",
    state: "active",
    marketSlug: "oscars-best-picture-2025",
  },
  {
    slug: "rising-tides",
    name: "Rising Tides",
    fanbase: "Indie Film Fans",
    acronym: "RT",
    price: "12.0",
    seed: "4",
    imageSrc: "#374151",
    primaryColor: "#374151",
    secondaryColor: "#1f2937",
    state: "active",
    marketSlug: "oscars-best-picture-2025",
  },
  {
    slug: "midnight-sonata",
    name: "Midnight Sonata",
    fanbase: "Music Lovers",
    acronym: "MS",
    price: "8.0",
    seed: "5",
    imageSrc: "#1e40af",
    primaryColor: "#1e40af",
    secondaryColor: "#111827",
    state: "active",
    marketSlug: "oscars-best-picture-2025",
  },
  {
    slug: "edge-of-tomorrow",
    name: "Edge of Tomorrow",
    fanbase: "Action Fans",
    acronym: "EOT",
    price: "6.0",
    seed: "6",
    imageSrc: "#047857",
    primaryColor: "#047857",
    secondaryColor: "#064e3b",
    state: "active",
    marketSlug: "oscars-best-picture-2025",
  },
  {
    slug: "silent-echoes",
    name: "Silent Echoes",
    fanbase: "Thriller Fans",
    acronym: "SE",
    price: "5.0",
    seed: "7",
    imageSrc: "#9ca3af",
    primaryColor: "#9ca3af",
    secondaryColor: "#4b5563",
    state: "active",
    marketSlug: "oscars-best-picture-2025",
  },
  {
    slug: "golden-horizon",
    name: "Golden Horizon",
    fanbase: "Adventure Fans",
    acronym: "GH",
    price: "4.0",
    seed: "8",
    imageSrc: "#a16207",
    primaryColor: "#a16207",
    secondaryColor: "#78350f",
    state: "active",
    marketSlug: "oscars-best-picture-2025",
  },
  {
    slug: "lost-in-reverie",
    name: "Lost in Reverie",
    fanbase: "Art-House Fans",
    acronym: "LIR",
    price: "3.0",
    seed: "9",
    imageSrc: "#be185d",
    primaryColor: "#be185d",
    secondaryColor: "#831843",
    state: "active",
    marketSlug: "oscars-best-picture-2025",
  },
  {
    slug: "fractured-paths",
    name: "Fractured Paths",
    fanbase: "Mystery Fans",
    acronym: "FP",
    price: "2.0",
    seed: "10",
    imageSrc: "#0e7490",
    primaryColor: "#0e7490",
    secondaryColor: "#082f49",
    state: "active",
    marketSlug: "oscars-best-picture-2025",
  },
]

// -----------------------------
// MLB 2025 – World Series top 10 contenders
// -----------------------------
export const mlbOutcomes: Outcome[] = [
  {
    slug: "atlanta-braves",
    name: "Atlanta Braves",
    fanbase: "Braves Country",
    acronym: "ATL",
    price: "18.0",
    seed: "1",
    imageSrc: "https://a.espncdn.com/combiner/i?img=/i/teamlogos/mlb/500/atl.png",
    primaryColor: "#CE1141",
    secondaryColor: "#13274F",
    state: "active",
    marketSlug: "mlb-world-series-2025",
  },
  {
    slug: "los-angeles-dodgers",
    name: "Los Angeles Dodgers",
    fanbase: "Dodger Blue",
    acronym: "LAD",
    price: "16.0",
    seed: "2",
    imageSrc: "https://a.espncdn.com/combiner/i?img=/i/teamlogos/mlb/500/lad.png",
    primaryColor: "#005A9C",
    secondaryColor: "#EF3E42",
    state: "active",
    marketSlug: "mlb-world-series-2025",
  },
  {
    slug: "baltimore-orioles",
    name: "Baltimore Orioles",
    fanbase: "Birdland",
    acronym: "BAL",
    price: "14.0",
    seed: "3",
    imageSrc: "https://a.espncdn.com/combiner/i?img=/i/teamlogos/mlb/500/bal.png",
    primaryColor: "#DF4601",
    secondaryColor: "#000000",
    state: "active",
    marketSlug: "mlb-world-series-2025",
  },
  {
    slug: "new-york-yankees",
    name: "New York Yankees",
    fanbase: "Yankees Universe",
    acronym: "NYY",
    price: "12.0",
    seed: "4",
    imageSrc: "https://a.espncdn.com/combiner/i?img=/i/teamlogos/mlb/500/nyy.png",
    primaryColor: "#003087",
    secondaryColor: "#E4002B",
    state: "active",
    marketSlug: "mlb-world-series-2025",
  },
  {
    slug: "houston-astros",
    name: "Houston Astros",
    fanbase: "Stros",
    acronym: "HOU",
    price: "9.0",
    seed: "5",
    imageSrc: "https://a.espncdn.com/combiner/i?img=/i/teamlogos/mlb/500/hou.png",
    primaryColor: "#EB6E1F",
    secondaryColor: "#002D62",
    state: "active",
    marketSlug: "mlb-world-series-2025",
  },
  {
    slug: "philadelphia-phillies",
    name: "Philadelphia Phillies",
    fanbase: "Philly Phans",
    acronym: "PHI",
    price: "8.5",
    seed: "6",
    imageSrc: "https://a.espncdn.com/combiner/i?img=/i/teamlogos/mlb/500/phi.png",
    primaryColor: "#E81828",
    secondaryColor: "#284898",
    state: "active",
    marketSlug: "mlb-world-series-2025",
  },
  {
    slug: "minnesota-twins",
    name: "Minnesota Twins",
    fanbase: "Twins Territory",
    acronym: "MIN",
    price: "7.5",
    seed: "7",
    imageSrc: "https://a.espncdn.com/combiner/i?img=/i/teamlogos/mlb/500/min.png",
    primaryColor: "#002B5C",
    secondaryColor: "#D31145",
    state: "active",
    marketSlug: "mlb-world-series-2025",
  },
  {
    slug: "texas-rangers",
    name: "Texas Rangers",
    fanbase: "Rangers Nation",
    acronym: "TEX",
    price: "7.0",
    seed: "8",
    imageSrc: "https://a.espncdn.com/combiner/i?img=/i/teamlogos/mlb/500/tex.png",
    primaryColor: "#003278",
    secondaryColor: "#C0111F",
    state: "active",
    marketSlug: "mlb-world-series-2025",
  },
  {
    slug: "cleveland-guardians",
    name: "Cleveland Guardians",
    fanbase: "Guardians Fans",
    acronym: "CLE",
    price: "6.5",
    seed: "9",
    imageSrc: "https://a.espncdn.com/combiner/i?img=/i/teamlogos/mlb/500/cle.png",
    primaryColor: "#E31937",
    secondaryColor: "#0C234B",
    state: "active",
    marketSlug: "mlb-world-series-2025",
  },
  {
    slug: "seattle-mariners",
    name: "Seattle Mariners",
    fanbase: "Mariners Fans",
    acronym: "SEA",
    price: "6.0",
    seed: "10",
    imageSrc: "https://a.espncdn.com/combiner/i?img=/i/teamlogos/mlb/500/sea.png",
    primaryColor: "#0C2C56",
    secondaryColor: "#005C5C",
    state: "active",
    marketSlug: "mlb-world-series-2025",
  },
]

// -----------------------------
// NCAAB 2026 – March Madness top 10 contenders
// -----------------------------
export const ncaab2026Outcomes: Outcome[] = [
  {
    slug: "kansas-jayhawks",
    name: "Kansas Jayhawks",
    fanbase: "Jayhawk Nation",
    acronym: "KU",
    price: "20.0",
    seed: "1",
    imageSrc: "https://a.espncdn.com/i/teamlogos/ncaa/500/2305.png",
    primaryColor: "#0051BA",
    secondaryColor: "#E51837",
    state: "active",
    marketSlug: "ncaab-march-madness-2026",
  },
  {
    slug: "duke-blue-devils",
    name: "Duke Blue Devils",
    fanbase: "Cameron Crazies",
    acronym: "DUKE",
    price: "18.0",
    seed: "2",
    imageSrc: "https://a.espncdn.com/i/teamlogos/ncaa/500/150.png",
    primaryColor: "#012169",
    secondaryColor: "#FFFFFF",
    state: "active",
    marketSlug: "ncaab-march-madness-2026",
  },
  {
    slug: "connecticut-huskies",
    name: "Connecticut Huskies",
    fanbase: "Husky Nation",
    acronym: "UCONN",
    price: "16.0",
    seed: "3",
    imageSrc: "https://a.espncdn.com/i/teamlogos/ncaa/500/41.png",
    primaryColor: "#001C4A",
    secondaryColor: "#C8102E",
    state: "active",
    marketSlug: "ncaab-march-madness-2026",
  },
  {
    slug: "houston-cougars",
    name: "Houston Cougars",
    fanbase: "Coogs",
    acronym: "UH",
    price: "14.0",
    seed: "4",
    imageSrc: "https://a.espncdn.com/i/teamlogos/ncaa/500/248.png",
    primaryColor: "#C8102E",
    secondaryColor: "#FFFFFF",
    state: "active",
    marketSlug: "ncaab-march-madness-2026",
  },
  {
    slug: "purdue-boilermakers",
    name: "Purdue Boilermakers",
    fanbase: "Boiler Nation",
    acronym: "PUR",
    price: "12.0",
    seed: "5",
    imageSrc: "https://a.espncdn.com/i/teamlogos/ncaa/500/2509.png",
    primaryColor: "#B5985A",
    secondaryColor: "#000000",
    state: "active",
    marketSlug: "ncaab-march-madness-2026",
  },
  {
    slug: "north-carolina-tar-heels",
    name: "North Carolina Tar Heels",
    fanbase: "Tar Heel Fans",
    acronym: "UNC",
    price: "10.0",
    seed: "6",
    imageSrc: "https://a.espncdn.com/i/teamlogos/ncaa/500/153.png",
    primaryColor: "#7BAFD4",
    secondaryColor: "#FFFFFF",
    state: "active",
    marketSlug: "ncaab-march-madness-2026",
  },
  {
    slug: "kentucky-wildcats",
    name: "Kentucky Wildcats",
    fanbase: "Big Blue Nation",
    acronym: "UK",
    price: "9.0",
    seed: "7",
    imageSrc: "https://a.espncdn.com/i/teamlogos/ncaa/500/96.png",
    primaryColor: "#0033A0",
    secondaryColor: "#FFFFFF",
    state: "active",
    marketSlug: "ncaab-march-madness-2026",
  },
  {
    slug: "arizona-wildcats",
    name: "Arizona Wildcats",
    fanbase: "Wildcat Fans",
    acronym: "AZ",
    price: "8.0",
    seed: "8",
    imageSrc: "https://a.espncdn.com/i/teamlogos/ncaa/500/12.png",
    primaryColor: "#003366",
    secondaryColor: "#C41230",
    state: "active",
    marketSlug: "ncaab-march-madness-2026",
  },
  {
    slug: "gonzaga-bulldogs",
    name: "Gonzaga Bulldogs",
    fanbase: "Zag Nation",
    acronym: "GU",
    price: "7.0",
    seed: "9",
    imageSrc: "https://a.espncdn.com/i/teamlogos/ncaa/500/2250.png",
    primaryColor: "#002B5C",
    secondaryColor: "#C8102E",
    state: "active",
    marketSlug: "ncaab-march-madness-2026",
  },
  {
    slug: "tennessee-volunteers",
    name: "Tennessee Volunteers",
    fanbase: "Vol Nation",
    acronym: "TEN",
    price: "6.0",
    seed: "10",
    imageSrc: "https://a.espncdn.com/i/teamlogos/ncaa/500/2633.png",
    primaryColor: "#FF8200",
    secondaryColor: "#FFFFFF",
    state: "active",
    marketSlug: "ncaab-march-madness-2026",
  },
]
